import { getEnv } from '@config';
import { store } from '@store/store';

const { withdrawalLimitFullProfile, withdrawalLimitIncompleteProfile } = getEnv();

/* eslint-disable no-use-before-define */
export const WITHOUT_SUBMITTING = 'WITHOUT SUBMITTING';
export const PENDING = 'PENDING';
export const APROVED = 'APPROVED';
export const REJECTED = 'REJECTED';
export const PENDING_TEXT = 'EN REVISION';
export const APROVED_TEXT = 'VERIFICADO';
export const WITHOUT_SUBMITTING_TEXT = 'SIN DOCUMENTACION';
export const REJECTED_TEXT = 'RECHAZADO';
export const PENDING_CLASS = 'pendingDocument';
export const APROVED_CLASS = 'aprovedDocument';
export const WITHOUT_SUBMITTING_CLASS = 'noPresentedDocument';
export const REJECTED_CLASS = 'rejectedDocument';
/* const DOC_TYPES_LENGHT = ["pjt6", "pjd6"]; */

const DocTypes = () => {
  const { docTypes } = store.getState().common;
  return docTypes;
};

export const getDocObject = (doc) => {
  const aux = Object.values(DocTypes()).filter((elm) => elm.code === doc);
  if (aux[0]) {
    return aux[0];
  }
  return { title: doc, preLink: 'falta popular' };
};

const limitFullProfile = Number(withdrawalLimitFullProfile);
const limitIncompleteProfile = Number(withdrawalLimitIncompleteProfile);

/**
 * fullProfile default: 7.000.000
 * incompleteProfile default: 500.000
 */
export const withdrawalLimit = {
  /** fullProfile default: 7.000.000 */
  fullProfile: limitFullProfile,
  /** incompleteProfile default: 500.000 */
  incompleteProfile: limitIncompleteProfile,
};

export const getFilesLength = (fileList) => fileList.length;
